import { useSetMobileCartShow } from "../atoms/useMobileCartShow";
import {
  defaultPosOrderCustomerPaymentAmount,
  useSetPosOrderCustomerPaymentAmount,
} from "../atoms/usePosOrderCustomerPaymentAmountAtom";
import {
  defaultPosOrderDeliveryCost,
  useSetPosOrderDeliveryCost,
} from "../atoms/usePosOrderDeliveryCostAtom";
import {
  defaultPosOrderCustomDiscount,
  useSetPosOrderCustomDiscount,
} from "../atoms/usePosOrderCustomDiscount";
import {
  defaultPosOrderHandOverDate,
  useSetPosOrderHandOverDate,
} from "../atoms/usePosOrderHandOverDateAtom";
import {
  defaultPosOrderMenuValues,
  useSetPosOrderMenuValues,
} from "../atoms/usePosOrderMenuValuesAtom";
import { useSetPosOrderRemark } from "../atoms/usePosOrderRemarkAtom";
import { useSetPosOrderSearch } from "../atoms/usePosOrderSearchAtom";
import { useSetPosOrderTable } from "../atoms/usePosOrderTable";
import {
  defaultPosOrderUser,
  useSetPosOrderUser,
} from "../atoms/usePosOrderUser";
import { useSetValidator } from "../atoms/usePosOrderValidatorAtom";
import { useSetPosShowPayment } from "../atoms/usePosShowPayment";
import { useSetPosTakeout } from "../atoms/usePosTakeout";
import useActiveOrdersSessionsRefetch from "../queries/orderssessions/useActiveOrdersSessionsRefetch";
import useDiscountCodeHook from "./useDiscountCodeHook";
import useIsOrderEditingHook from "./useIsOrderEditingHook";
import usePosOrderStandardHook from "./usePosOrderStandardHook";
import usePosOrderTipHook from "./usePosOrderTipHook";
import { useSetCart } from "./useCartHook";
import {
  defaultPosOrderServiceCost,
  useSetPosOrderServiceCost,
} from "../atoms/usePosOrderServiceCostAtom";
import { useSetPosOrderSessionData } from "../atoms/usePosOrderTableSessionAtoms";
import { useResetSplitPaymentAtoms } from "../atoms/useSplitPaymentV2Atom";

const usePosOrderResetHook = () => {
  const setPosShowPayment = useSetPosShowPayment();
  const refetchActiveSessions = useActiveOrdersSessionsRefetch();
  const setTable = useSetPosOrderTable();
  const setPosOrderValues = useSetPosOrderMenuValues();
  const setPosOrderUser = useSetPosOrderUser();
  const setPosOrderDeliveryCost = useSetPosOrderDeliveryCost();
  const { setEditOrder } = useIsOrderEditingHook();
  const setPosOrderRemark = useSetPosOrderRemark();
  const { setTip: setPosOrderTip } = usePosOrderTipHook();
  const setCart = useSetCart();
  const setSearch = useSetPosOrderSearch();
  const { resetDiscountCode } = useDiscountCodeHook();
  const setValidator = useSetValidator();
  const setCustomDiscount = useSetPosOrderCustomDiscount();
  const resetSplitPaymentAtoms = useResetSplitPaymentAtoms();
  const setCustomerPaymentAmount = useSetPosOrderCustomerPaymentAmount();
  const setMobileCartShow = useSetMobileCartShow();
  const setPosOrderHandOverDate = useSetPosOrderHandOverDate();
  const setPosTakeout = useSetPosTakeout();
  const { setStandardDeliveryMethod, setStandardPaymentMethod } =
    usePosOrderStandardHook();
  const setPosOrderServiceCost = useSetPosOrderServiceCost();
  const setPosOrderSessionData = useSetPosOrderSessionData();

  const reset = (
    resetTable = true,
    afterPost = false,
    resetStandard = true
  ) => {
    setPosShowPayment(false);
    if (resetTable) {
      setTable(null);
      refetchActiveSessions();
    }
    setPosTakeout(false);
    if (resetStandard) {
      setStandardDeliveryMethod(afterPost);
      setStandardPaymentMethod();
    }
    setCustomDiscount(defaultPosOrderCustomDiscount);
    setValidator(undefined);
    resetDiscountCode();
    setPosOrderValues(defaultPosOrderMenuValues);
    setPosOrderUser(defaultPosOrderUser);
    setPosOrderDeliveryCost(defaultPosOrderDeliveryCost);
    setEditOrder({});
    setPosOrderRemark("");
    setPosOrderTip("-1");
    setCart([]);
    setCustomerPaymentAmount(defaultPosOrderCustomerPaymentAmount);
    setMobileCartShow(false);
    resetSplitPaymentAtoms();
    setSearch((draft) => {
      draft.text = "";
      draft.barcode = "";
    });
    setPosOrderHandOverDate(defaultPosOrderHandOverDate);
    setPosOrderServiceCost(defaultPosOrderServiceCost);
    setPosOrderSessionData(null);
  };
  return reset;
};

export default usePosOrderResetHook;
